
import { getStatusBarInfo, nativeGoBack,doJump } from "@/utils/nativeFn";
import { useRoute } from 'vue-router'
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
export default {
  name: "PhotoCorrectResult",
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const flag = ref(0)
    let { type } = useRoute().query || {};
    console.log(type)
    const title = ref("")
    onMounted(()=>{
      if(type === "1" ){
        title.value ='没有找到作答题目'
        flag.value = 1
        // 没有作答题目蒙层曝光
        $xesLog.track('pho_check_page_without_finish_show', {})
      }else{
        title.value ='没有找到可批改的题目'
        flag.value = 2
        // 没有批改题目蒙层曝光
        $xesLog.track('pho_check_page_without_exer_show', {})
      }
    })
    const doJumpFn = () => {
      // 查看支持图书列表按钮点击
      $xesLog.track('pho_check_page_without_exer_pho_sup_click', {
        biz_name:'paipai',
        page_name:'拍照批改页',
        event_name:'拍照批改页-『没有找到可批改的题目』浮层-『查看支持图书』按钮点击（H5）',
        event_type:'click',
        event_id:'pho_check_page_without_exer_pho_sup_click'
      })
      let base  = window.location.href.split('#')[0]
      let path = `10001?parameters=${encodeURIComponent(
          JSON.stringify({
            url: `${base}#/support-book-list?jump=2&hideNavBar=1`
          })
        )}`
      doJump(path, () => {
      console.log("跳转成功");
    });
    }
    return {
      title,
      flag,
      doJumpFn
    };
  },
};
